import { useState } from 'react';
import { FiUser } from 'react-icons/fi';
import { useTranslation } from 'react-i18next';
import { DirectoryFormModal } from '../Directory/DirectoryFormModal';
import { FormField, inputClassName } from '../ui/FormField';

const CustomerForm = ({ showCustomerForm, onClose, onSubmit, customer, setCustomer, type }) => {
  const { t } = useTranslation();
  const [submitting, setSubmitting] = useState(false);

  const update = (field) => (event) => setCustomer((current) => ({ ...current, [field]: event.target.value }));
  const submit = async (event) => {
    event.preventDefault();
    if (submitting) return;
    setSubmitting(true);
    try { await onSubmit(event); } finally { setSubmitting(false); }
  };

  return (
    <DirectoryFormModal
      open={showCustomerForm}
      onClose={onClose}
      onSubmit={submit}
      title={type === 'Add' ? t('Add New Customer') : t('Edit customer information')}
      description={t('Manage customer contact details.')}
      icon={FiUser}
      submitLabel={submitting ? t('Processing...') : type === 'Add' ? t('Add') : t('Edit')}
      cancelLabel={t('Cancel')}
      closeLabel={t('Close')}
      submitting={submitting}
      width={820}
    >
      <div className='grid gap-4 sm:grid-cols-2'>
        <FormField label={t('First Name')} required><input autoFocus type='text' autoComplete='given-name' className={inputClassName} value={customer.firstName || ''} onChange={update('firstName')} required /></FormField>
        <FormField label={t('Last Name')} required><input type='text' autoComplete='family-name' className={inputClassName} value={customer.lastName || ''} onChange={update('lastName')} required /></FormField>
        <FormField label={t('Email')} required><input type='email' autoComplete='email' className={inputClassName} value={customer.email || ''} onChange={update('email')} required /></FormField>
        <FormField label={t('Phone Number')} required><input type='tel' autoComplete='tel' className={inputClassName} value={customer.phoneNumber || ''} onChange={update('phoneNumber')} required /></FormField>
        <div className='pb-3 sm:col-span-2'><FormField label={t('Home Address')} required><input type='text' autoComplete='street-address' className={inputClassName} value={customer.homeAddress || ''} onChange={update('homeAddress')} required /></FormField></div>
      </div>
    </DirectoryFormModal>
  );
};

export default CustomerForm;
